export const needsOrganisationDetails = (
  user?: { needs_organisation_details?: boolean } | null
): boolean => user?.needs_organisation_details ?? true
